export const styles = theme => ({
    dataContainer: {
        backgroundColor: '#fafafa',
        '& .amountContainer h6': {
            lineHeight: '1.8em'
        }
    },
    componentDiv: {
        minHeight: '200px',
        paddingTop: '20px',
        [theme.breakpoints.up('md')]: {
            width: '90%',
            marginLeft: 'auto',
            marginRight: 'auto',
        }

    },
    modalDialog: theme.dialogDimentions,
    paper: {
        backgroundColor: 'white !important',
        marginBottom: '10px',
        padding: '25px 20px',
        [theme.breakpoints.up('md')]: {
            padding: "25px 15px 25px 30px",
        }
    },
    movilPaper: {
        display: 'block',
        backgroundColor: 'white !important',
        marginBottom: '10px',
        padding: '12px 20px',
        [theme.breakpoints.up('md')]: {
            padding: "25px 15px 25px 30px",
            display: 'none'
        }
    },
    desktopPaper: {
        display: 'none',
        backgroundColor: 'white !important',
        marginBottom: '2px',
        padding: `${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px`,
        [theme.breakpoints.up('md')]: {
            padding: "25px 15px 25px 30px",
            display: 'block'
        }
    },
    itemsPaper: {
        marginBottom: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    wellDoneSpace: {
        marginRight: '15px',
        marginLeft: '15px',
        padding: '15px',
        [theme.breakpoints.up('sm')]: {
            padding: '30px',
            width: "80%",
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    colorPaper: {
        display: 'inherit',
        padding: '2.5px',
        marginLeft: '5px',
        [theme.breakpoints.up('sm')]: {
            padding: '5px',
            marginLeft: 0,
        }
    },
    itemMainDiv: {
        display: 'flex',
        flexWrap: 'noWrap',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        }
    },
    itemHeader: {
        display: "flex",
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: -10,
        [theme.breakpoints.up('md')]: {
            flexDirection: 'column',
            marginLeft: 'initial',
        },
    },
    separator: {
        display: 'flex',
        flexGrow: 1,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        },
    },
    issuesDesktop: {
        display: 'none',
        flexWrap: 'wrap-reverse',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginTop: '15px',
        [theme.breakpoints.up('md')]: {
            display: 'block',
            flexGrow: 1,
            marginLeft: '30px',
            marginRight: '5px',
            marginTop: 0,
        },
    },
    issuesMobil: {
        display: 'block',
        marginTop: '8px',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    colorName: {
        fontSize: '11px',
        marginLeft: '5px'
    },
    registerButton: {
        display: 'block',
        width: '85%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '20px',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        },
    },
    registerButtonDesktop: {
        display: 'none',
        width: '200px',
        marginLeft: 'auto',
        marginTop: '20px',
        [theme.breakpoints.up('md')]: {
            display: 'block'
        },
    },
    registerDivDesktop: {
        display: 'none',
        marginBottom: 'initial',
        [theme.breakpoints.up('md')]: {
            display: 'block',
            marginBottom: '30px',
        },
    },
    fixedPaper: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        paddingBottom: '15px',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        },
    },
    aptmInfo: {
        marginTop: 5,
        [theme.breakpoints.up('md')]: {
            marginTop: 10,
        }
    },
    otherSpace: {
        display: 'flex',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '50px',
        [theme.breakpoints.up('sm')]: {
            marginTop: '25px',
            width: '86%',
        },
    },
    avatar: {
        width: '50px',
        height: '50px',
        background: 'white',
    },
    headerDiv: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 'fit-content',
        [theme.breakpoints.up('sm')]: {
            alignItems: 'initial',
            width: 'initial',
            marginRight: 'initial',
            marginLeft: 'initial',
        }
    },
    headerTypography: {
        color: 'white',
        fontWeight: 'bold',
        marginLeft: '30px'
    },
    paragraph: {
        color: 'white',
        textAlign: 'center',
        marginRight: 'auto',
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginLeft: '80px',
            marginTop: '-10px',
            textAlign: 'initial',
        }
    },
});
